module.exports = __webpack_public_path__ + "img/_4.4776b623.png";